// Sample messages for the UI-only version of the Chat Simulator.
// Each outbound item has the same shape the chat service will receive later:
//   { msgId, ts, direction: 'out', payload: <Turn.io message payload> }
// User messages: { msgId, ts, direction: 'in', payload: { type: 'text', text: { body } } }
// See docs/chat-interface/02-api-contract.md

const now = Date.now()
const t = (minsAgo) => now - minsAgo * 60 * 1000

export default [
  {
    msgId: 'sample-1',
    ts: t(10),
    direction: 'out',
    payload: {
      type: 'text',
      text: { body: '*Welcome to Nivi!* 👋\nI can help you with _health information_.\nLearn more: https://nivi.io' }
    }
  },
  {
    msgId: 'sample-2',
    ts: t(9),
    direction: 'in',
    payload: { type: 'text', text: { body: 'Hi' } }
  },
  {
    msgId: 'sample-3',
    ts: t(8),
    direction: 'out',
    payload: {
      type: 'image',
      image: { link: 'https://placehold.co/600x400/png?text=Sample+Image' }
    }
  },
  {
    msgId: 'sample-4',
    ts: t(7),
    direction: 'out',
    payload: {
      type: 'text',
      preview_url: true,
      text: { body: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4' }
    }
  },
  {
    msgId: 'sample-5',
    ts: t(6),
    direction: 'out',
    payload: {
      type: 'interactive',
      interactive: {
        type: 'button',
        body: { text: 'What would you like to know about?' },
        action: {
          buttons: [
            { type: 'reply', reply: { id: '1', title: 'Pregnancy' } },
            { type: 'reply', reply: { id: '2', title: 'Vaccines' } },
            { type: 'reply', reply: { id: '3', title: 'Family planning' } }
          ]
        }
      }
    }
  },
  {
    msgId: 'sample-6',
    ts: t(5),
    direction: 'in',
    payload: {
      type: 'interactive',
      interactive: { type: 'button_reply', button_reply: { id: '2', title: 'Vaccines' } }
    }
  },
  {
    msgId: 'sample-7',
    ts: t(4),
    direction: 'out',
    payload: {
      type: 'interactive',
      interactive: {
        type: 'list',
        body: { text: 'Which vaccine do you want to learn about?' },
        action: {
          button: 'Options',
          sections: [{
            rows: [
              { id: '1', title: 'HPV' },
              { id: '2', title: 'Measles' },
              { id: '3', title: 'Polio' },
              { id: '4', title: 'Tetanus' }
            ]
          }]
        }
      }
    }
  },
  {
    msgId: 'sample-8',
    ts: t(3),
    direction: 'out',
    payload: {
      type: 'interactive',
      interactive: {
        type: 'location_request_message',
        body: { text: 'Share your location so we can find a clinic near you.' },
        action: { name: 'send_location' }
      }
    }
  },
  {
    msgId: 'sample-audio',
    ts: t(4),
    direction: 'out',
    payload: {
      type: 'audio',
      audio: { link: 'https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3' }
    }
  },
  {
    msgId: 'sample-8b',
    ts: t(3),
    direction: 'out',
    payload: {
      type: 'image',
      image: {
        link: 'https://placehold.co/600x600/f6b73c/6b2f12/png?text=EXTRA+7%25+OFF',
        caption: '*Great Comfort Sale* is live! 🎉\nGet up to _65% OFF_ plus extra 7% OFF.\nShop now: https://nivi.io'
      }
    }
  },
  {
    msgId: 'sample-9',
    ts: t(2),
    direction: 'out',
    payload: {
      type: 'template',
      template: { name: 'great_comfort_sale', language: { code: 'en' }, components: [] }
    },
    // UI-only: later filled in by the chat service from the Turn template
    resolvedTemplate: {
      header: { type: 'image', link: 'https://placehold.co/600x600/f6b73c/6b2f12/png?text=EXTRA+7%25+OFF' },
      body: 'Hey there,\n\nYour recent order of *Neeman\'s* comes with an exciting offer and is ready to be delivered.\n\nHere is the special offer: *GREAT COMFORT SALE* is live with *up to 65% OFF* plus *extra 7% OFF* with *GCS7*. Best picks are selling out fast. Grab yours favorites before they\'re gone.\n\nClick below for more details.',
      footer: 'Type STOP to Unsubscribe',
      buttons: [{ type: 'URL', text: 'Click Here', url: 'https://nivi.io' }]
    }
  },
  {
    msgId: 'sample-10',
    ts: t(1),
    direction: 'out',
    payload: {
      type: 'interactive',
      interactive: {
        type: 'flow',
        body: { text: 'Fill up this survey' },
        action: { name: 'flow', parameters: { flow_id: '123', flow_cta: 'Open form' } }
      }
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/chat-simulator/sampleMessages.js